/* Guarda Mundo - Media carousel (spec 0034)
 * Setas + barra de indice 2px pra galeria/foto principal. Scroll-snap nativo;
 * o JS so avanca o scroll e sincroniza a barra com o slide ativo. Inerte no
 * modo pilha (desktop stack): viewport nao rola no eixo X.
 */

(() => {
  'use strict';

  const activeIndex = (viewport) => {
    const slideWidth = viewport.clientWidth || 1;
    return Math.round(viewport.scrollLeft / slideWidth);
  };

  const setActive = (root, index) => {
    const count = parseInt(root.dataset.count || '1', 10);
    const clamped = Math.max(0, Math.min(index, count - 1));
    root.style.setProperty('--gm-media-active', String(clamped));
  };

  const scrollToIndex = (viewport, index) => {
    const slideWidth = viewport.clientWidth || 0;
    viewport.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
  };

  const bind = (root) => {
    const viewport = root.querySelector('[data-gm-media-viewport]');
    const count = parseInt(root.dataset.count || '1', 10);
    if (!viewport || count <= 1) return;

    const prev = root.querySelector('[data-gm-media-prev]');
    const next = root.querySelector('[data-gm-media-next]');

    const go = (delta) => {
      const target = activeIndex(viewport) + delta;
      // Loop: passou do fim volta pro inicio, e vice-versa.
      const wrapped = ((target % count) + count) % count;
      scrollToIndex(viewport, wrapped);
      setActive(root, wrapped);
    };

    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));

    let ticking = false;
    viewport.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          setActive(root, activeIndex(viewport));
          ticking = false;
        });
      },
      { passive: true },
    );

    setActive(root, 0);
  };

  const init = () => {
    document.querySelectorAll('[data-gm-media-carousel]').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
